import axiosInst from "../../Config";
import { Decrypt_Value } from "../EncryptDecrypt";

const Pat_ID =
  localStorage.getItem("PID") &&
  Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

export const RefundList_Api = async () =>
  // Endpoint: api/vozo/patient/refundlists with patient id
  await axiosInst.get(`/vozo/patient/refundlists?pid=${Pat_ID}`);
